import GoogleFeedItem from "./GoogleFeedItem";
import HNFeedItem from "./HNFeedItem";
import GenericFeedItem from "./GenericFeedItem";

export default {
    0: { name: "Basic RSS", component: GenericFeedItem },
    1: { name: "Hacker News", component: HNFeedItem },
    2: { name: "Google News", component: GoogleFeedItem }
};